import { render, staticRenderFns } from "./TestInformationManagement.vue?vue&type=template&id=70a48eb0&scoped=true"
import script from "./TestInformationManagement.vue?vue&type=script&lang=js"
export * from "./TestInformationManagement.vue?vue&type=script&lang=js"
import style0 from "./TestInformationManagement.vue?vue&type=style&index=0&id=70a48eb0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a48eb0",
  null
  
)

export default component.exports